<script setup lang="ts"></script>

<template>
    <div class="flex align-items-stretch">
        <footer
            class="flex text-[2.5rem] font-bold leading-[inherit] self-stretch bg-[#161d1e] min-h-30 p-8 text-center w-full justify-center"
        >
            <img
                class="max-w-33"
                :src="'/img/sign-up/logo.svg'"
                alt="Preno"
            />
        </footer>
    </div>
</template>

<style scoped></style>
